import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import CommonWrapper from '../../../components/ui_components/FounderWrapper';
import colors from '../../../styles/colors';
import { useAppSelector } from '../../../store/hooks';

const PageInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 24px;
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: gold;
  margin-bottom: 48px;
  text-align: center;
`;

const CardsRow = styled.div`
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
  justify-content: center;
`;

const NavCard = styled.button`
  width: 240px;
  height: 160px;
  background-color: ${colors.bgColorBlack2};
  border: 2px solid gold;
  border-radius: 10px;
  color: gold;
  font-size: 22px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.15s;

  &:hover {
    background-color: ${colors.bgSfondoColor};
    transform: scale(1.03);
  }
`;

const CatalogLandingPage: React.FC = () => {
  const navigate = useNavigate();
  const user = useAppSelector((state) => state.auth.user ?? state.auth.userLoggedState);
  const isFounder = !!user?.is_founder;

  return (
    <CommonWrapper>
      <PageInner>
        <Title>Admin Catalog — {isFounder ? 'Founder Panel' : 'Admin Panel'}</Title>
        <CardsRow>
          <NavCard onClick={() => navigate('/admin/catalog/dashboard')}>
            Dashboard
          </NavCard>

          {isFounder && (
            <>
              <NavCard onClick={() => navigate('/admin/catalog/cards')}>
                Carte
              </NavCard>
              <NavCard onClick={() => navigate('/admin/catalog/expansions')}>
                Espansioni
              </NavCard>
              <NavCard onClick={() => navigate('/admin/catalog/packs')}>
                Pacchetti
              </NavCard>
              <NavCard onClick={() => navigate('/admin/catalog/settings')}>
                Impostazioni
              </NavCard>
            </>
          )}

          <NavCard onClick={() => navigate('/admin/catalog/quiz')}>
            Quiz
          </NavCard>

          <NavCard onClick={() => navigate('/admin/users')}>
            Crediti Utenti
          </NavCard>
        </CardsRow>
      </PageInner>
    </CommonWrapper>
  );
};

export default CatalogLandingPage;
